var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"appWrapper",class:_vm.$style.wrapper},[_c('div',{style:([_vm.margin !== null ? _vm.contentMargin : '']),attrs:{"id":_vm.$style.content}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }